


































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { CvType, CvValue, FieldMetadataAccount } from '@/models'

const SELECT_TYPE_CODE = 'fmat-sel'
const INDEFINITE_TYPE_CODE = 'fmat-indef'
// Field codes are jsonb keys in account.meta and JS property names: camelCase only.
const FIELD_CODE_REGEX = /^[a-z][a-zA-Z0-9]*$/

function emptyForm(): FieldMetadataAccount {
  return { fieldCode: '', companyId: '', typeId: '', optionsId: null, label: '', required: false, displayOrder: 0 }
}

@Component
export default class UpsertAccountFieldModal extends Vue {
  @Prop({ required: false }) field: FieldMetadataAccount | null
  @Prop({ required: true }) companyId: string
  @Prop({ default: () => [] }) typeOptions: CvValue[]
  @Prop({ default: () => [] }) cvTypes: CvType[]

  private form: FieldMetadataAccount = emptyForm()
  private saving = false

  @Watch('field', { deep: true })
  onFieldChanged() {
    this.form = this.field && this.field.id ? { ...this.field } : emptyForm()
  }

  get isNew(): boolean {
    return this.field == null || !this.field.id
  }

  get isSelectType(): boolean {
    return this.form.typeId === SELECT_TYPE_CODE
  }

  // null = neutral (empty), true/false drive the field validation styling.
  get fieldCodeState(): boolean | null {
    if (!this.form.fieldCode) return null
    return FIELD_CODE_REGEX.test(this.form.fieldCode)
  }

  // "Indefinido" is not a real field type; keep it out of the picker.
  get selectableTypes(): CvValue[] {
    return this.typeOptions.filter(type => type.codeId !== INDEFINITE_TYPE_CODE)
  }

  onTypeChange() {
    // Options only make sense for select fields; clear them otherwise.
    if (!this.isSelectType) {
      this.form.optionsId = null
    }
  }

  private formOk(): boolean {
    if (!this.form.fieldCode || !this.form.typeId) return false
    if (!FIELD_CODE_REGEX.test(this.form.fieldCode)) return false
    if (this.isSelectType && !this.form.optionsId) return false
    return true
  }

  hideModal() {
    this.$bvModal.hide('UpsertAccountFieldModal')
  }

  private saveForm(): void {
    if (!this.formOk() || this.saving) return

    const payload: FieldMetadataAccount = {
      ...this.form,
      companyId: this.isNew ? this.companyId : this.form.companyId,
      optionsId: this.isSelectType ? this.form.optionsId : null
    }

    const promise = this.isNew
      ? ApiClient.createFieldMetadataAccount(payload)
      : ApiClient.updateFieldMetadataAccount(this.field!.id as number, payload)

    this.saving = true
    promise
      .then((saved: FieldMetadataAccount) => {
        this.$emit('fieldSaved', saved)
        this.hideModal()
        this.form = emptyForm()
      })
      .catch((ex: Error) => {
        this.$bvToast.toast(ex.message, {
          title: this.$t('account_metadata_view.error_title').toString(),
          variant: 'danger',
          solid: true
        })
      })
      .finally(() => {
        this.saving = false
      })
  }
}
